<div class="content-heading">
  <div class="header-container">
    <h3>Reporte de Flujos</h3>
    <small>Reporte Web</small>
  </div>
</div>

<div class="container-fluid">
  <div class="card card-default shadow-sm border-0">
    <div class="card-body">
      
      <div class="row">
        <div class="col-md-6">
          <label>Organización Origen</label>
          <aph-custom-select 
            [items]="organizacionList"
            bindLabel="UnitDescription"
            bindValue="UnitId"
            type="default"
            placeholder="-- Seleccione Organización --"
            (onSelectionChange)="changeFilterOrgOri()"
            [selectedValue]="orgSelectedOri"
            (returnValue)="orgSelectedOri = $event">
          </aph-custom-select>
        </div>
        <div class="col-md-6">
          <label>Origen</label>
          <aph-custom-select 
            [items]="origenList"
            bindLabel="UnitDes"
            bindValue="UnitId"
            [showDefaultOption]="true" 
            defaultLabel="Todos" 
            [defaultValue]="0" 
            [selectedValue]="0"
            type="default"
            placeholder="-- Seleccione Origen --"
            (returnValue)="Ori = $event">
          </aph-custom-select>
        </div>
      </div>

      <div class="row mt-3">
        <div class="col-md-6">
          <label>Organización Destino</label>
          <aph-custom-select 
            [items]="organizacionList"
            bindLabel="UnitDescription"
            bindValue="UnitId"
            type="default"
            placeholder="-- Seleccione Organización --"
            (onSelectionChange)="changeFilterOrgDes()"
            [selectedValue]="orgSelectedDes"
            (returnValue)="orgSelectedDes = $event">
          </aph-custom-select>
        </div>
        <div class="col-md-6">
          <label>Destino</label>
          <aph-custom-select 
            [items]="destinoList"
            bindLabel="UnitDes"
            bindValue="UnitId"
            type="default"
            [showDefaultOption]="true" 
            defaultLabel="Todos" 
            [defaultValue]="0" 
            [selectedValue]="0"
            placeholder="-- Seleccione Destino --"
            (returnValue)="Dest = $event">
          </aph-custom-select>
        </div>
      </div>

      <div class="row mt-4">
        <div class="col-12">
          <aph-custom-buttons 
            preset="excel" 
            [label]="downloading ? 'Descargando...' : 'Descargar reporte'" 
            [loading]="downloading" 
            (btnClick)="download()">
          </aph-custom-buttons>
        </div>
      </div>

    </div>
  </div>
</div>